<template>
  <div style="padding:20px;height:100vh;box-sizing:border-box;">
    <div style="position: relative;height: calc(100vh - 60px);">
      <div v-if="previewUrl" style="
        width: 100%;
        height:100%;
        border: 1px solid #e4e7ed;
        border-radius: 4px;
        overflow: auto;
        background-color: #f5f7fa;
      ">
        <div v-if="isDocxFile(previewName)" ref="docxContainer" style="padding:20px;height:100%;overflow:auto;"></div>
        <iframe v-else-if="isPreviewableDocument(previewName)" :src="previewUrl"
                style="width: 100%; height: 100%; border: none"></iframe>
        <el-image v-else-if="isImageFile(previewName)" :src="previewUrl" fit="contain"
                  style="width: 100%; height: 100%"></el-image>
        <video v-else-if="isVideoFile(previewName)" :src="previewUrl"
               style="width: 100%; height: 100%; object-fit: contain" controls></video>
        <div v-else-if="previewType === 'text'" style="padding: 20px; height: 100%; overflow-y: auto">
          <pre style="white-space: pre-wrap; word-wrap: break-all">{{ previewContent }}</pre>
        </div>
        <div v-else style="padding: 40px;text-align: center;height: 100%;display: flex;
align-items: center;justify-content: center;">
          <i class="el-icon-document" style="font-size: 64px; color: #409eff; margin-bottom: 20px"></i>
          <div style="color: #606266; font-size: 16px; word-break: break-all">
            {{ previewName || getFileName(previewUrl) }}
          </div>
          <div style="color: #909399; font-size: 14px; margin-top: 10px">
            不支持在线预览，请下载查看
          </div>
          <el-button type="primary" style="margin-top: 20px" @click="downloadFile()">下载文件</el-button>
        </div>
      </div>
      <div v-else style="height:100%;display:flex;align-items:center;justify-content:center">
        <i class="el-icon-loading" style="font-size:30px"></i>
        <span style="margin-left:8px">加载中...</span>
      </div>
    </div>
  </div>
</template>

<script>
import { renderAsync } from 'docx-preview'
export default {
  name: "FilePreview",
  data() {
    return {
      previewUrl: '',
      previewName: '',
      previewType: '',
      previewContent: '',
    }
  },
  created() {
    this.previewUrl = this.$route.query.url
    this.previewName = this.$route.query.name
    this.loadPreview()
  },
  watch: {
    $route(to) {
      this.previewUrl = to.query.url
      this.previewName = to.query.name
      this.loadPreview()
    }
  },
  methods: {
    async loadPreview() {
      if (!this.previewUrl) return
      this.previewType = 'other'
      this.previewContent = ''
      if (this.$refs.docxContainer) this.$refs.docxContainer.innerHTML = ''
      if (this.isImageFile(this.previewName)) {
        this.previewType = 'image'
      } else if (this.isPreviewableDocument(this.previewName)) {
        this.previewType = 'pdf'
      } else if (this.isVideoFile(this.previewName)) {
        this.previewType = 'video'
      } else if (this.isTextFile(this.previewName)) {
        this.previewType = 'text'
        await this.loadTextFile(this.previewUrl)
      } else if (this.isDocxFile(this.previewName)) {
        this.previewType = 'docx'
        await this.loadDocx(this.previewUrl)
      }
    },
    isDocxFile(fileName) {
      const suffix = this.getFileSuffix(fileName)
      return suffix === 'docx'
    },
    async loadDocx(url) {
      try {
        const res = await fetch(url)
        const blob = await res.blob()
        await renderAsync(blob, this.$refs.docxContainer, null, {
          className: 'docx-preview',
          ignoreLastRenderedPageBreak: true
        })
      } catch (err) {
        console.error('docx预览失败', err)
        this.$message.error('docx文档预览失败')
      }
    },
    isImageFile(fileName) {
      const imgSuffix = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
      const suffix = this.getFileSuffix(fileName)
      return imgSuffix.includes(suffix)
    },
    isPreviewableDocument(fileName) {
      const docSuffix = ['pdf']
      const suffix = this.getFileSuffix(fileName)
      return docSuffix.includes(suffix)
    },
    isVideoFile(fileName) {
      const videoSuffix = ['mp4', 'webm', 'ogg']
      const suffix = this.getFileSuffix(fileName)
      return videoSuffix.includes(suffix)
    },
    isTextFile(fileName) {
      const textSuffix = ['txt', 'json', 'md', 'csv']
      const suffix = this.getFileSuffix(fileName)
      return textSuffix.includes(suffix)
    },
    getFileSuffix(fileName) {
      if (!fileName) return ''
      const nameArr = fileName.split('.')
      if (nameArr.length < 2) return ''
      return nameArr.pop().toLowerCase()
    },
    getFileName(url) {
      if (!url) return ''
      return url.substring(url.lastIndexOf('/') + 1)
    },
    async loadTextFile(url) {
      try {
        const res = await fetch(url)
        this.previewContent = await res.text()
      } catch (e) {
        this.previewContent = '文本内容读取失败'
      }
    },
    downloadFile() {
      if (!this.previewUrl) return
      const a = document.createElement('a')
      a.href = this.previewUrl
      a.download = this.previewName || this.getFileName(this.previewUrl)
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
  }
}
</script>
